<div
  [class.layout-live-orders]="isLiveOrdersPage()"
  class="layout-container"
  [class]="['layout-container-' + sidenavMode()]"
>
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
      #snav
      class="sidenav"
      [class]="['sidenav-' + sidenavMode()]"
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="!isMobile() && !isHidden()"
      [disableClose]="!isMobile()"
      fixedTopGap="56"
    >
      @if (hasExpandableItems()) {
        <mat-accordion
          class="nav-list"
          [class]="[
            isSidenavExpanded() ? 'nav-list-detailed' : 'nav-list-compact',
          ]"
          [multi]="false"
        >
          <div
            class="flex flex-row items-center gap-[5px] p-[5px] mb-4"
            [class]="sidenavHeaderClass()"
          >
            @if (isMobile()) {
              <button mat-icon-button (click)="snav.toggle()" class="back-nav">
                <mat-icon>keyboard_backspace</mat-icon>
              </button>
            }

            <div [class]="sidenavLogoWrapperClass()">
              <img
                [src]="getLogoSource()"
                [alt]="getLogoAlt()"
                [width]="getLogoWidth()"
                [style.margin]="getLogoMargin()"
              />

              <span
                class="ord-hint text-slate-300"
                [class]="sidenavVersionClass()"
              >
                v{{ version }}
              </span>
            </div>
          </div>

          @for (nav of sidenavItems(); track nav) {
            @if (nav.children && nav.children.length > 0) {
              <mat-expansion-panel
                *hasRole="nav.allowedRoles"
                class="sub-nav-list"
                [expanded]="
                  (isFull() || isMiniExpanded()) &&
                  currentUrl().includes(nav.path)
                "
                [hideToggle]="isMiniCollapsed()"
                (opened)="onExpansionPanelOpened()"
              >
                <mat-expansion-panel-header class="sub-nav-header">
                  <span class="nav-item-content">
                    <mat-icon
                      class="nav-icon"
                      mat-list-icon
                      [matTooltip]="isMiniCollapsed() ? nav.name : ''"
                      [matTooltipShowDelay]="500"
                      [svgIcon]="nav.icon"
                    ></mat-icon>
                    <span class="nav-text">
                      {{ nav.name }}
                    </span>
                  </span>
                </mat-expansion-panel-header>
                <mat-nav-list dense class="sub-nav-items">
                  @for (child of nav.children; track child) {
                    <a
                      *hasRole="child.allowedRoles"
                      mat-list-item
                      [routerLink]="child.path"
                      routerLinkActive="active-link"
                    >
                      <span class="nav-item-content">
                        @if (child.icon) {
                          <mat-icon
                            class="nav-icon"
                            mat-list-icon
                            [svgIcon]="child.icon"
                          ></mat-icon>
                        }
                        <span class="nav-text">
                          {{ child.name }}
                        </span>
                      </span>
                    </a>
                  }
                </mat-nav-list>
              </mat-expansion-panel>
            }
            @if (!nav.children || nav.children.length == 0) {
              <a
                *hasRole="nav.allowedRoles"
                mat-list-item
                routerLinkActive="active-link"
                [routerLink]="nav.path"
                [matTooltip]="isMiniCollapsed() ? nav.name : ''"
                [matTooltipShowDelay]="500"
                (click)="closeExpansionPanels()"
              >
                <div class="nav-item-content">
                  <mat-icon
                    class="nav-icon"
                    mat-list-icon
                    [svgIcon]="nav.icon"
                  ></mat-icon>
                  <div class="nav-text" matBadge="4" matBadgeOverlap="false">
                    <span> {{ nav.name }} </span>
                    @if (nav.badge) {
                      <span class="menu-badge">{{ nav.badge }}</span>
                    }
                  </div>
                </div>
              </a>
            }
          }
          @if (isMini()) {
            <button
              mat-icon-button
              (click)="toggleMini()"
              class="nav-toggle"
              aria-label="Expand side navigation"
            >
              <mat-icon
                color="primary"
                svgIcon="mini-expand"
                class="nav-icon"
              ></mat-icon>
            </button>
          }
        </mat-accordion>
      } @else {
        <mat-nav-list
          class="nav-list"
          [class]="
            isSidenavExpanded() ? 'nav-list-detailed' : 'nav-list-compact'
          "
        >
          <div
            class="flex flex-row items-center gap-[5px] p-[5px] mb-4"
            [class]="sidenavHeaderClass()"
          >
            @if (isMobile()) {
              <button mat-icon-button (click)="snav.toggle()" class="back-nav">
                <mat-icon>keyboard_backspace</mat-icon>
              </button>
            }

            <div [class]="sidenavLogoWrapperClass()">
              <img
                [src]="getLogoSource()"
                [alt]="getLogoAlt()"
                [width]="getLogoWidth()"
                [style.margin]="getLogoMargin()"
              />

              <span
                class="ord-hint text-slate-300"
                [class]="sidenavVersionClass()"
              >
                v{{ version }}
              </span>
            </div>
          </div>

          @for (nav of sidenavItems(); track nav) {
            <a
              *hasRole="nav.allowedRoles"
              mat-list-item
              routerLinkActive="active-link"
              [routerLink]="nav.path"
              [matTooltip]="isMiniCollapsed() ? nav.name : ''"
              [matTooltipShowDelay]="500"
              (click)="closeExpansionPanels()"
            >
              <div class="nav-item-content">
                <mat-icon
                  class="nav-icon"
                  mat-list-icon
                  [svgIcon]="nav.icon"
                ></mat-icon>
                <div class="nav-text" matBadge="4" matBadgeOverlap="false">
                  <span> {{ nav.name }} </span>
                  @if (nav.badge) {
                    <span class="menu-badge">{{ nav.badge }}</span>
                  }
                </div>
              </div>
            </a>
          }

          @if (isMini()) {
            <button
              mat-icon-button
              (click)="toggleMini()"
              class="nav-toggle"
              aria-label="Expand side navigation"
            >
              <mat-icon
                color="primary"
                svgIcon="mini-expand"
                class="nav-icon"
              ></mat-icon>
            </button>
          }
        </mat-nav-list>
      }
    </mat-sidenav>

    <mat-sidenav-content
      class="sidenav-content"
      [@onSidenavChange]="isHidden() ? 'hidden' : sidenavMode()"
    >
      <mat-toolbar class="toolbar">
        <ng-container>
          <mat-toolbar-row>
            @if (isMobile()) {
              <button mat-icon-button (click)="snav.toggle()">
                <mat-icon>menu</mat-icon>
              </button>
            }
            @if (isDisplayManageRegisterButton()) {
              <button mat-button routerLink="/registers/open-close-register">
                <mat-icon>point_of_sale</mat-icon>
                <span>Manage Register</span>
              </button>
            }
            @if (isDisplayBackToPosButton()) {
              <button mat-button routerLink="/registers/point-of-sales">
                <mat-icon>shopping_cart</mat-icon>
                <span>Go to POS</span>
              </button>
            }

            @if (isOffline()) {
              <div class="text-yellow-500 text-sm">
                ( &#x26A0; Offline Mode - Changes will sync when online )
              </div>
            }

            <span class="toolbar-spacer"></span>

            @if (!pageData().isLoading) {
              @if (!isMobile()) {
                @if (isDisplayTransactionControls()) {
                  <app-pos-transaction-controls />
                }

                <!-- Store and register selectors -->
                @if (isDisplayCurrentStoreAndRegister()) {
                  <!-- Store selector -->
                  <button mat-button>
                    <mat-icon>store</mat-icon>
                    <div class="menu-label">
                      <span class="text-black">{{ storeName() ?? "--" }}</span>
                    </div>
                  </button>

                  <!-- Register selector -->
                  <button mat-button type="button">
                    <mat-icon svgIcon="cash-register"></mat-icon>
                    <div class="menu-label">
                      <p class="text-black">
                        @if (registerName()) {
                          {{ registerName() }}
                        } @else {
                          --
                        }
                      </p>
                    </div>
                  </button>
                }
              }

              <app-notification-panel-trigger />

              <button mat-button [matMenuTriggerFor]="profileMenu">
                <mat-icon>person</mat-icon>
                <div class="menu-label">
                  Account <mat-icon> expand_more </mat-icon>
                </div>
              </button>
              <mat-menu #profileMenu="matMenu">
                <div id="profile-name">
                  Hi {{ currentUser()?.firstName }}
                  <small>{{ currentUser()?.role }}</small>
                </div>
                <button mat-menu-item (click)="goToNotificationsPage()">
                  Notifications
                </button>
                <button mat-menu-item (click)="goToProfilePage()">
                  Settings
                </button>
                @if (!isOffline()) {
                  <button mat-menu-item (click)="handleSignout()">
                    Sign Out
                  </button>
                }
              </mat-menu>
              @if (isPosPage()) {
                <button
                  mat-icon-button
                  (click)="toggleFullscreen()"
                  [matTooltip]="isHidden() ? 'Exit Fullscreen' : 'Fullscreen'"
                  [matTooltipShowDelay]="500"
                >
                  <mat-icon>{{
                    isHidden() ? "fullscreen_exit" : "fullscreen"
                  }}</mat-icon>
                </button>
              }
            } @else {
              <!-- Placeholder skeleton -->
              @if (!isMobile()) {
                @if (isDisplayTransactionControls()) {
                  <app-pos-transaction-controls-skeleton />
                }
                @if (isDisplayCurrentStoreAndRegister()) {
                  <div class="px-1">
                    <app-skeleton class="h-6 w-40" />
                  </div>
                  <div class="px-1">
                    <app-skeleton class="h-6 w-40" />
                  </div>
                }
              }
              <div class="px-1">
                <app-skeleton class="h-6 w-24" />
              </div>
            }
          </mat-toolbar-row>
        </ng-container>

        <ng-container *ngIf="isMobile() && isDisplayCurrentStoreAndRegister()">
          <mat-toolbar-row>
            @if (!pageData().isLoading) {
              <button mat-button>
                <mat-icon>store</mat-icon>
                <div class="menu-label">
                  <span class="text-black">{{ storeName() ?? "--" }}</span>
                </div>
              </button>
            } @else {
              <div class="px-1">
                <app-skeleton class="h-6 w-40" />
              </div>
            }
          </mat-toolbar-row>
        </ng-container>
        <ng-container *ngIf="isMobile() && isDisplayCurrentStoreAndRegister()">
          <mat-toolbar-row>
            @if (!pageData().isLoading) {
              <button mat-button type="button">
                <mat-icon svgIcon="cash-register"></mat-icon>
                <div class="menu-label">
                  <p class="text-black">
                    @if (registerName()) {
                      {{ registerName() }}
                    } @else {
                      --
                    }
                  </p>
                </div>
              </button>
            } @else {
              <div class="px-1">
                <app-skeleton class="h-6 w-40" />
              </div>
            }
          </mat-toolbar-row>
        </ng-container>
        <ng-container *ngIf="isMobile() && isDisplayTransactionControls()">
          <mat-toolbar-row>
            @if (!pageData().isLoading) {
              <app-pos-transaction-controls />
            } @else {
              <app-pos-transaction-controls-skeleton />
            }
          </mat-toolbar-row>
        </ng-container>
      </mat-toolbar>

      <div
        class="page-content"
        [class]="
          isPosPage() ? 'page-fill-height' : 'px-3 pt-3 sm:px-8 sm:pt-8 pb-32'
        "
        [class.page-live-orders]="isLiveOrdersPage()"
      >
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- Footer -->
<footer
  class="z-50 fixed bottom-0 right-0 flex gap-1 items-center justify-center w-full h-5 bg-slate-800"
  [class]="footerPaddingClass()"
>
  <span class="text-[10px] text-slate-300 hover:text-slate-50 cursor-default"
    >&copy; 2026 Orderna Inc. v{{ version }}</span
  >
</footer>
